import React from "react";
import styled from "styled-components";

import { DefaultContent } from "../../../../layout/AppLayout/ModalDialog/components";
import UISubheader from "../../../../ui/Typography/Subheader";
import RegularTextSmall from "../../../../ui/Typography/RegularTextSmall";
import { Wrapper as EmptyStateWrapper } from "../../../../ui/EmptyState";

const StyledContent = styled(DefaultContent)`
  min-height: 70vh;
  width: auto;
  min-width: 560px;
  display: flex;
`;

export const Content = props => <StyledContent {...props} />;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: inherit;
  width: 750px;
  max-width: 100%;
  box-sizing: border-box;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export const Header = styled.div`
  padding: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const Subheader = styled(UISubheader)`
  margin-bottom: 24px;
`;

export const StatusLabel = styled(RegularTextSmall)`
  margin-bottom: 8px;
`;

export const GridSection = styled.div`
  padding-left: 24px;
`;

export const GridWrapper = styled.div`
  border-bottom: ${({ showBorder }) =>
    showBorder && "1px solid rgba(0, 0, 0, 0.12)"};
  ${EmptyStateWrapper} {
    margin-left: -24px;
  }
  th,
  td {
    &:first-child {
      padding-left: 0;
    }
  }
`;

export const ActionWrapper = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const StatusLine = styled.div`
  display: flex;
  align-items: center;
  > * {
    line-height: 20px;
    margin-right: 16px;
  }
`;

export const DescriptionSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px 24px;
  ${({ divider }) =>
    divider ? "border-bottom: 1px solid rgba(0, 0, 0, 0.12);" : ""}

  > * {
    flex: 1;
    min-width: 0;
  }
`;

export const OverrideSection = styled.div`
  flex-basis: 100%;
  flex-grow: 0;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;

// A percentage height has nothing definite to resolve against inside the
// scrolling modal, so the dashboard collapses and its texts overlap. A fixed
// height must also fit a selected file's thumbnail between Uppy's header and
// its upload footer without scrolling.
export const DASHBOARD_HEIGHT = 335;
